import {FC, ReactNode, useMemo, useState} from "react";
import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";
import styled from "styled-components";
import {FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {ProjectCardTitle} from "../projectCard/styles";
import {LmsTitle} from "../TeamCard/TeamCard";
import {useGetLMSDisciplines} from "../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../helpers/LMS/getDisciplineColorFromId";
import {useSelector} from "react-redux";
import {OrganizationsState} from "../../reducers/OrganizationsSlice";
import { Endpoints, Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useTeam } from "shared/hooks/useTeam";

const Wrapper = styled(FlexBox)<{color?: string, coverImage?: string}>`
    width: 100%;
    height: 100%;
    padding: 47px 24px 24px 24px;
    background-color: ${({color, coverImage}) => coverImage ? 'transparent' : (color || BASE_DISCIPLINE_COLOR)};
    background-image: ${({coverImage}) => coverImage ? `url(${coverImage})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

  
    @media(max-width: ${LayoutConst.screen.l}px) {
      padding: 31px 16px 16px 16px;
    }

  ${ProjectCardTitle}, ${LmsTitle} {

    font-size: 30px!important;
    font-style: normal;
    font-weight: 600;
    line-height: 40px!important;
    letter-spacing: -0.02em;
    padding: 0px!important;

    @media(max-width: ${LayoutConst.screen.l}px) {
      font-size: 17px!important;
      line-height: 22px!important;
    }
  }
`;


export const LMSModuleCover: FC<{title?: ReactNode, discipline?: string, color?: string, style?: any, project?: Project<'Global'> | Project<'Local'>}> = ({title, style = {}, discipline = '', color, project}) => {

    const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);
    const excludedContexts = ["lmsproject", "lmshseproject", "hsedesign"];
    const matchingContext = project?.contexts?.find(
      (context) => !excludedContexts.includes(context)
    );
    const [date] = useState(Date.now());
    const { i18n } = useTranslation();
    const disableRequest = !!storedTeam?.teamId;
    const team = useTeam(matchingContext || '', date , i18n.language, disableRequest)
    const { colors: disciplineColors } = useGetLMSDisciplines(storedTeam?.teamId || team?.teamId || '')

    const coverImage = useMemo(() => {
        const images: any[] = (project as any)?.titleImages || [];
        const img = images.find((f: any) => f.size === 'original') || images[0];
        return img?.url ? `${Endpoints.files}/${img.url}` : undefined;
    }, [(project as any)?.titleImages]);

    const bgColor = useMemo(() => {
      return project?.additionalInfo?.moduleColor || getDisciplineColorFromId(discipline, disciplineColors)
    }, [project, discipline, disciplineColors])

    return <Wrapper style={style} color={bgColor} coverImage={coverImage}>
        {!coverImage && title}
    </Wrapper>
}import {FC, ReactNode, useMemo, useState} from "react";
import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";
import styled from "styled-components";
import {FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {ProjectCardTitle} from "../projectCard/styles";
import {LmsTitle} from "../TeamCard/TeamCard";
import {useGetLMSDisciplines} from "../../hooks/api/LMS/useGetLMSDisciplines";
import {getDisciplineColorFromId} from "../../helpers/LMS/getDisciplineColorFromId";
import {useSelector} from "react-redux";
import {OrganizationsState} from "../../reducers/OrganizationsSlice";
import { Endpoints, Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useTeam } from "shared/hooks/useTeam";

const Wrapper = styled(FlexBox)<{color?: string, coverImage?: string}>`
    width: 100%;
    height: 100%;
    padding: 47px 24px 24px 24px;
    background-color: ${({color, coverImage}) => coverImage ? 'transparent' : (color || BASE_DISCIPLINE_COLOR)};
    background-image: ${({coverImage}) => coverImage ? `url(${coverImage})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

  
    @media(max-width: ${LayoutConst.screen.l}px) {
      padding: 31px 16px 16px 16px;
    }

  ${ProjectCardTitle}, ${LmsTitle} {

    font-size: 30px!important;
    font-style: normal;
    font-weight: 600;
    line-height: 40px!important;
    letter-spacing: -0.02em;
    padding: 0px!important;

    @media(max-width: ${LayoutConst.screen.l}px) {
      font-size: 17px!important;
      line-height: 22px!important;
    }
  }
`;


export const LMSModuleCover: FC<{title?: ReactNode, discipline?: string, color?: string, style?: any, project?: Project<'Global'> | Project<'Local'>}> = ({title, style = {}, discipline = '', color, project}) => {

    const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);
    const excludedContexts = ["lmsproject", "lmshseproject", "hsedesign"];
    const matchingContext = project?.contexts?.find(
      (context) => !excludedContexts.includes(context)
    );
    const [date] = useState(Date.now());
    const { i18n } = useTranslation();
    const disableRequest = !!storedTeam?.teamId;
    const team = useTeam(matchingContext || '', date , i18n.language, disableRequest)
    const { colors: disciplineColors } = useGetLMSDisciplines(storedTeam?.teamId || team?.teamId || '')

    const coverImage = useMemo(() => {
        const images: any[] = (project as any)?.titleImages || [];
        const img = images.find((f: any) => f.size === 'original') || images[0];
        return img?.url ? `${Endpoints.files}/${img.url}` : undefined;
    }, [(project as any)?.titleImages]);

    const bgColor = useMemo(() => {
      return project?.additionalInfo?.moduleColor || getDisciplineColorFromId(discipline, disciplineColors)
    }, [project, discipline, disciplineColors])

    return <Wrapper style={style} color={bgColor} coverImage={coverImage}>
        {!coverImage && title}
    </Wrapper>
}